import gql from 'graphql-tag'

export const GET_ALL_PROJECTS = gql`
  query AllProjectsPaginated(
    $brandUuid: ID
    $projectStates: [ProjectState]
    $projectLevels: [ProjectLevel]
    $pageSize: Int
    $orderDirection: OrderDirection
  ) {
    allProjectsPaginated(
      brandUuid: $brandUuid
      states: $projectStates
      projectLevels: $projectLevels
      pageSize: $pageSize
      orderDirection: $orderDirection
    ) {
      projects {
        name
        uuid
        dueDate
        projectLevel
        thumbnailUrl
        state
        location {
          address
          city
          country
        }
        shoots {
          uuid
          location {
            address
            city
            country
          }
        }
        videos {
          uuid
          location {
            address
            city
            country
          }
        }
        price {
          currency {
            code
            symbol
          }
          amount
        }
        customerContract {
          controllingCompany {
            tradingName
            uuid
          }
          lostAt
          signingDate
          signedAt
          invoices {
            total {
              amount
            }
            price {
              currency {
                code
                symbol
              }
              amount
            }
          }
          projects {
            name
            uuid
            dueDate
          }
        }
        submitter {
          name
        }
        jobs {
          dueDate
          name
          totalPrice {
            amount
            currency {
              symbol
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/GetAllProjectsv2.tsx